import script from "./RoleDataForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleDataForm.vue?vue&type=script&setup=true&lang=ts"

import "./RoleDataForm.vue?vue&type=style&index=0&id=525b1d84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525b1d84"]])

export default __exports__